import {
  Button,
  Col,
  Modal,
  Row,
  Space,
  Typography,
  Tabs,
  Card,
  Spin,
  Tooltip,
  message,
  Form,
} from "../../common/utils/antd-imports/AntdImports";
import React, { useCallback, useEffect, useState } from "react";
import "./MakeOffer.css";
import FloatingInput from "../../common/float-input/FloatInput";
import FloatingTextArea from "../../common/floating-textarea/FloatingTextArea";
import { useDispatch, useSelector } from "react-redux";
import { offerPriceRequest } from "../../../store/thunks/buyer-thunks/BuyerThunks";
import { getOfferDetails } from "../../../store/thunks/seller-thunks/SellerThunk";
import "../../../main.css";
import FormItem from "antd/es/form/FormItem";
import { CopyOutlined } from "@ant-design/icons";
import { handleCopy } from "../../common/utils/Utils";
import { debounce, delay } from "lodash";

const MakeOffer = ({
  offerModal,
  totalPrice,
  setOfferModal,
  campaignProducts,
  campaignId,
  loggedinUser,
  offerListFromCampaign,
  offerListLoader,
}) => {
  const { Text } = Typography;
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [comments, setComments] = useState({});
  const [offerPrice, setOfferPrice] = useState("");
  const [userOfferList, setUserOfferList] = useState([]);
  const [campaignComment, setCampaignComment] = useState("");
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const [activeCommentIndex, setActiveCommentIndex] = useState(null);
  const { isLoading: offerRequestLoader, offerRequestStatus } = useSelector(
    (state) => state.offerPrice
  );
  const [errorMessage, setErrorMessage] = useState("");
  const { offerList: modalOfferList, isLoading: offersListLoader } =
    useSelector((state) => state.sellerCampaigns);
  const [isTabDisabled, setIsTabDisabled] = useState(false);
  useEffect(() => {
    setUserOfferList(offerListFromCampaign);
    if (
      offerListFromCampaign?.length == 1 &&
      (offerListFromCampaign[0]?.status === 10 ||
        offerListFromCampaign[0]?.status === 20)
    ) {
      setIsTabDisabled(true);
    } else if (offerListFromCampaign?.length == 2) setIsTabDisabled(true);
    if (offerListFromCampaign?.length > 0) {
      setUserOfferList(
        offerListFromCampaign?.map((offer, index) => {
          if (offer.status === 10) {
            return {
              ...offer,
              status: "Requested",
            };
          } else if (offer.status === 20 || offer.status === 30) {
            return {
              ...offer,
              status: "Accepted",
            };
          } else if (offer.status === 40 || offer.status === 50) {
            return {
              ...offer,
              status: "Rejected",
            };
          }
        })
      );
    }
  }, [offerListFromCampaign]);

  useEffect(() => {
    if (!offerRequestLoader && offerRequestStatus)
      dispatch(getOfferDetails(campaignId));
  }, [offerRequestLoader]);

  useEffect(() => {
    if (offersListLoader && modalOfferList) setUserOfferList(modalOfferList);
  }, [offersListLoader]);
  const handleAddComment = (index, productId) => {
    setComments((prevComments) => ({
      ...prevComments,
      [productId]: "",
    }));
    if (activeCommentIndex === index) {
      setComments((prevComments) => ({
        ...prevComments,
        [productId]: "",
      }));
      setActiveCommentIndex(null);
    } else {
      setActiveCommentIndex(index);
    }
  };

  const handleCommentChange = (index, productId, value) => {
    setComments((prev) => ({
      ...prev,
      [productId]: value,
    }));
    setActiveCommentIndex((prevIndex) =>
      prevIndex !== index ? index : prevIndex
    );
  };
  const getCommentedProductIds = () => {
    return Object.entries(comments)
      ?.filter(([_, comment]) => comment.trim() !== "") // Keep only non-empty comments
      ?.map(([productId, _]) => productId); // Extract just the IDs
  };
  const getCommentedValues = () => {
    return Object.values(comments)?.filter((comment) => comment.trim() !== "");
  };

  const getAdminOfferAcceptRejectPayload = () => {
    const filteredEntries = Object.entries(comments)?.filter(
      ([_, comment]) => comment.trim() !== ""
    );

    return Object.fromEntries(
      filteredEntries?.map(([productId]) => [productId, 0])
    );
  };

  // Delay check on offer price input
  const validateDebouncedValue = useCallback(debounce((offerPrice) =>{
    if(offerPrice && Number(offerPrice) > Number(totalPrice)){
        setErrorMessage(
        `Offer must be below $${Number(totalPrice)?.toFixed(2)}`
      );
    }
    else {
      setErrorMessage("");
    }
  },delay),[totalPrice,delay]
);

// Checking if the entered offer price exceeds totalprice 
  const handleOfferPrice = (e) =>{
          const value = e.target.value.trim();
          setOfferPrice(value);
          validateDebouncedValue(value);
  }

  const handleSaveOffer = () => {
    const payload = {
      campaign_id: campaignId,
      loggedinUser,
      price: offerPrice,
      comments: campaignComment,
      product_booking_ids: getCommentedProductIds(),
      product_comments: getCommentedValues(),
      AdminOfferAcceptReject: getAdminOfferAcceptRejectPayload(),
    };
    dispatch(offerPriceRequest(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        setOfferPrice("");
        setCampaignComment("");
        dispatch(getOfferDetails(campaignId));
        setOfferModal(false);
      }
    });
  };

  const getTooltipContent = () => {
    if (userOfferList?.length === 1) {
      if (userOfferList[0].status == "Requested")
        return "You cannot make request until the offer status is changed.";
      else if (offerListFromCampaign[0]?.status === 20)
        return "You cannot make further offer requests once your offer has been accepted.";
    }
    if (userOfferList?.length === 2)
      return "Only 2 offers can be requested for a campaign";
  };
  const offerPriceInput = (
    <FormItem
      style={{ width: "100%" }}
      rules={[
        {
          required: true,
          message: "Offer Price is required!",
        },
      ]}
    >
      <FloatingInput
        type="number"
        onWheel={(e) => e.target.blur()}
        inputMode="decimal"
        pattern="[0-9]*"
        onKeyDown={(e) => {
          if (["e", "E", "+", "-"].includes(e.key)) {
            e.preventDefault();
          }
        }}
        className="billboard-input-feild"
        label={
          <>
            {`Offer Price `}
            {star}
          </>
        }
        customStyles={floatingInputStyles}
        value={offerPrice}
        disabled={isTabDisabled}
        onChange={handleOfferPrice}
      />
      <span className="error-block">{errorMessage}</span>
    </FormItem>
  );
  const campaignCommentTextArea = (
    <FormItem
      style={{ width: "100%" }}
      rules={[
        {
          required: true,
          message: "Comments is required!",
        },
      ]}
    >
      <FloatingTextArea
        className="billboard-input-feild billboard-text-area"
        customStyles={textAreaFloatingInputStyles}
        disabled={isTabDisabled}
        value={campaignComment}
        onChange={(e) => {
          const value = e.target.value;
          setCampaignComment(value);
        }}
        label={
          <>
            {`Comments`}
            {star}
          </>
        }
      />
    </FormItem>
  );
  const tabContent = [
    {
      label: "Make Offer",
      key: "make_offer",
      children: (
        <div className="make-offer-container">
          <Form
            onFinish={() => {
              handleSaveOffer();
            }}
            form={form}
          >
            <Space
              direction="vertical"
              size={25}
              className="make-offer-container-space"
            >
              <Row>
                <Text className="campaign-offer-text">
                  Offer for Entire Campaign
                </Text>
              </Row>

              <Row>
                {isTabDisabled ? (
                  <Tooltip title={getTooltipContent()}>
                    {offerPriceInput}
                  </Tooltip>
                ) : (
                  <>{offerPriceInput}</>
                )}
              </Row>
              <Row>
                {isTabDisabled ? (
                  <Tooltip title={getTooltipContent()}>
                    {campaignCommentTextArea}
                  </Tooltip>
                ) : (
                  <>{campaignCommentTextArea}</>
                )}
              </Row>

              <Row>
                <Text className="campaign-offer-text">
                  Want to comment on specific products?
                </Text>
              </Row>
              <div className="products-list">
                {campaignProducts &&
                  campaignProducts?.map((product, index) => (
                    <div key={product?.id} className="campaign-product">
                      <Row>
                        <Col span={12}>
                          <div className="product-copy-text-field">
                            <Tooltip title={product?.title}>
                              <Text className="campaign-product-name make-offer-truncate">
                                {product?.title}
                              </Text>
                            </Tooltip>
                            <CopyOutlined
                              onClick={(e) => {
                                e.stopPropagation(); // prevent tooltip close
                                handleCopy(product?.title);
                              }}
                              className="copy-icon"
                            />
                          </div>
                        </Col>
                        <Col span={12} className="add-comment-col">
                          {isTabDisabled ? (
                            <Tooltip title={getTooltipContent()}>
                              <Button
                                className={`add-comment-btn ${
                                  isTabDisabled ? "disabled-opacity" : ""
                                }`}
                                onClick={() =>
                                  handleAddComment(index, product?.id)
                                }
                                disabled={isTabDisabled}
                              >
                                <Text
                                  className="add-comment-btn-text"
                                  disabled={isTabDisabled}
                                >
                                  {activeCommentIndex === index ||
                                  comments[product?.id]
                                    ? "Remove Comment"
                                    : "Add Comment"}
                                </Text>
                              </Button>
                            </Tooltip>
                          ) : (
                            <Button
                              className="add-comment-btn"
                              onClick={() =>
                                handleAddComment(index, product?.id)
                              }
                            >
                              <Text
                                className="add-comment-btn-text"
                                disabled={isTabDisabled}
                              >
                                {activeCommentIndex === index ||
                                comments[product?.id]
                                  ? "Remove Comment"
                                  : "Add Comment"}
                              </Text>
                            </Button>
                          )}
                        </Col>
                      </Row>
                      {(activeCommentIndex === index ||
                        comments[product?.id]) && (
                        <Row>
                          <FloatingTextArea
                            value={comments[product?.id] || ""}
                            onChange={(e) =>
                              handleCommentChange(
                                index,
                                product?.id,
                                e.target.value
                              )
                            }
                            label={<>{`Comments`}</>}
                            className="billboard-input-feild billboard-text-area"
                            customStyles={textAreaFloatingInputStyles}
                          />
                        </Row>
                      )}
                    </div>
                  ))}
              </div>
            </Space>
            <Row align="middle" justify="center">
              {isTabDisabled ? (
                <Tooltip title={getTooltipContent()}>
                  <Button
                    className="offer-Submit-btn"
                    disabled={isTabDisabled}
                    onClick={() => {
                      form.submit();
                    }}
                  >
                    <Text className="offer-Submit-btn-text">Submit </Text>
                  </Button>
                </Tooltip>
              ) : (
                <Button
                  className={`offer-Submit-btn ${
                    isTabDisabled || !offerPrice || !campaignComment || errorMessage
                      ? "disabled-opacity"
                      : ""
                  }`}
                  disabled={isTabDisabled || !offerPrice || !campaignComment}
                  onClick={() => form.submit()}
                >
                  <Text className="offer-Submit-btn-text">Submit </Text>
                </Button>
              )}
            </Row>
          </Form>
        </div>
      ),
    },
    {
      label: "My Offer",
      key: "my_offer",
      children: (
        <>
          <div className="my-offer-requests">
            <div className="submitted-label">Submitted Offers</div>
            {userOfferList?.length > 0 ? (
              <>
                {userOfferList?.map((offer, index) => {
                  return (
                    <div key={index}>
                      <div className="offer-numbers">Offer #{index + 1}</div>
                      <Card className="offer-card">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <span className="offer-label">Offer Price:</span>
                            <span className="price-value">${offer?.price}</span>
                          </div>
                          <div
                            className={`offer-status ${
                              offer?.status
                                ?.toString()
                                ?.trim()
                                ?.toLowerCase() == "rejected"
                                ? "offer-status"
                                : "offer-status-accept"
                            }`}
                          >
                            {offer?.status}
                          </div>
                        </div>
                        <div>
                          <div className="offer-label comments">Comments</div>
                          {offer?.comments}
                        </div>
                        {offer.product_comments?.map((product) => {
                          return (
                            <Card
                              style={{
                                marginTop: "1rem",
                                marginBottom: "1rem",
                              }}
                            >
                              <div style={{ margin: "1rem 0" }}>
                                <span className="price-label">
                                  {product?.product_title}
                                </span>
                              </div>
                              <div>
                                <span className="product-comments-label comments">
                                  Comments :
                                </span>
                                <span className="price-value">
                                  {product?.product_comments}
                                </span>
                              </div>
                            </Card>
                          );
                        })}
                      </Card>
                    </div>
                  );
                })}
              </>
            ) : (
              <Card className="no-offer-card">No Offers Requested</Card>
            )}
          </div>
        </>
      ),
    },
  ];
  const onTabChange = (key) => {};

  return (
    <>
      <Modal
        height={"90vh"}
        width={438}
        className="offer-modal"
        open={offerModal}
        onCancel={() => setOfferModal(false)}
        closable={true}
        footer={false}
      >
        <Row>
          <Text className="make-offer-txt">Make an Offer</Text>
        </Row>

        <Tabs defaultActiveKey="1" items={tabContent} onChange={onTabChange} />
        {(offerListLoader || offerRequestLoader) && (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        )}
      </Modal>
    </>
  );
};
export default MakeOffer;
